<template>
	<div>
		<v-layout row justify-center>
			<v-dialog
				:value="true"
				scrollable
				fullscreen
				hide-overlay>
				<div v-shortkey="['esc']" @shortkey="$emit('close')"></div>
				<v-card color="background">
					<v-card-title class="pa-0 primary">
						<v-spacer></v-spacer>
						<span class="title color--text">
							{{ toolbarTitle }}
						</span>
						<v-spacer></v-spacer>
						<v-btn large icon class="m-1 color--text" @click="$emit('close')">
							<v-icon large>close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text class="pa-0">
						<TitleAssetFinder
							:multiselect="multiselect"
							:no_select="no_select"
							:title="title"
							:customer_code="customer_code"
							:asset_type="asset_type"
							:babel_id="babel_id"
							:babel_label="babel_label"
							:behive_category="behive_category"
							:return_file_paths="return_file_paths"
							:return_objects="return_objects"
							@asset-selected="$emit('selectedAssets', $event);$emit('close')">
						</TitleAssetFinder>
					</v-card-text>
				</v-card>
			</v-dialog>
		</v-layout>

	</div>
</template>

<script>
import TitleAssetFinder from '@/pages/filesystem/title_asset_finder.vue'
export default {
	props: [
		'toolbarTitle',
		'multiselect',
		'no_select',
		'title',
		'customer_code',
		'asset_type',
		'babel_id',
		'babel_label',
		'behive_category',
		'return_file_paths',
		'return_objects'
	],
	name: 'title_asset_finder_modal',
	components: { TitleAssetFinder }
}
</script>

<style scoped lang="stylus">
.v-card__title
	max-height: 48px
</style>



// WEBPACK FOOTER //
// src/components/modal_title_asset_finder.vue